import React, { useCallback, useEffect, useState } from "react";
import { FieldProps } from "react-jsonschema-form";

import SelectGroup from "../../witadmin/CRUD/Common/SelectGroup";
import styled from "styled-components";

const SelectGroupWrapper = styled.div`
  display: flex;
  max-width: 200px;
  margin-bottom: -20px;
`;

const currentYear = new Date().getFullYear();
const dayN = new Array(31).fill("");
const monthN = new Array(12).fill("");
const yearN = new Array(121).fill("");

function selectOptions(it: any) {
  return it.reduce((accum: any, curr: any, index: any) => {
    return { [index + 1]: { label: index + 1 }, ...accum };
  }, {});
}

const dayOptions = { ...selectOptions(dayN), 0: { label: "" } };
const monthOptions = { ...selectOptions(monthN), 0: { label: "" } };
const yearOptions = {
  ...yearN.reduce((accum: any, curr: any, index: any) => {
    return { [currentYear - index]: { label: currentYear - index }, ...accum };
  }, {}),
  0: { label: "" },
};

export function DOBSelector({ formData, onChange, schema }: FieldProps) {
  const [day, setDay] = useState(0);
  const [month, setMonth] = useState(0);
  const [year, setYear] = useState(0);

  useEffect(() => {
    if (Object.keys(formData).length && Object.values(formData).some(it => it !== 0)) {
      // @ts-ignore
      const protoDate = new proto.google.protobuf.Timestamp();
      protoDate.setSeconds(formData.seconds);
      protoDate.setNanos(formData.nanos);
      const date = protoDate.toDate();
      setDay(date.getUTCDate());
      setMonth(date.getUTCMonth() + 1);
      setYear(date.getUTCFullYear());
    }
  }, [formData]);

  const handleChange = useCallback(
    (event, type) => {
      let lDay = day;
      let lMonth = month;
      let lYear = year;

      if (type === "day") {
        setDay(event.target.value);
        lDay = event.target.value;
      }
      if (type === "month") {
        setMonth(event.target.value);
        lMonth = event.target.value;
      }
      if (type === "year") {
        setYear(event.target.value);
        lYear = event.target.value;
      }

      if (lDay && lMonth && lYear) {
        const date = new Date(Date.UTC(lYear, lMonth - 1, lDay));
        // @ts-ignore
        const birthDate = new proto.google.protobuf.Timestamp();
        birthDate.fromDate(date);
        onChange(birthDate.toObject());
      }
    },
    [onChange, day, month, year]
  );

  return (
    <>
      <label>{schema?.title}</label>
      <SelectGroupWrapper>
        <SelectGroup
          value={day}
          field={{
            fieldName: "type",
            widget: "selector",
            optionDisplay: dayOptions,
          }}
          onChange={({ event, field }) => {
            handleChange(event, "day");
          }}
          errors={undefined}
          additionalFields={undefined}
          className={undefined}
        />
        <SelectGroup
          value={month}
          field={{
            fieldName: "type",
            widget: "selector",
            optionDisplay: monthOptions,
          }}
          onChange={({ event, field }) => {
            handleChange(event, "month");
          }}
          errors={undefined}
          additionalFields={undefined}
          className={undefined}
        />
        <SelectGroup
          value={year}
          field={{
            fieldName: "type",
            widget: "selector",
            optionDisplay: yearOptions,
          }}
          onChange={({ event, field }) => {
            handleChange(event, "year");
          }}
          errors={undefined}
          additionalFields={undefined}
          className={undefined}
        />
      </SelectGroupWrapper>
    </>
  );
}
